import { render, staticRenderFns } from "./CatalogLoadDialog.vue?vue&type=template&id=63867fdc&scoped=true&"
import script from "./CatalogLoadDialog.vue?vue&type=script&lang=js&"
export * from "./CatalogLoadDialog.vue?vue&type=script&lang=js&"
import style0 from "./CatalogLoadDialog.vue?vue&type=style&index=0&id=63867fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63867fdc",
  null
  
)

export default component.exports